import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Profile } from '../../models/profile.model';
import { Specialty } from '../../models/specialty.model';

import { Router } from '@angular/router';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import moment from 'moment';
import { StorageService } from 'src/app/core/services/storage.service';
import { getFirstHospitalSelectedData } from 'src/app/shared/utils/cross-functions';
import { Hospital } from '../../models/hospital.model';
import { Paramedical } from '../../models/paramedical.model';
import { Role } from '../../models/role.model';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-smart-op-avatar',
  templateUrl: './smart-op-avatar.component.html',
  styleUrls: ['./smart-op-avatar.component.scss'],
  standalone: false,
})
export class SmartOpAvatarComponent implements OnInit, OnChanges {
  @Input() public clipName: boolean = false;

  @Input() public hoverHighlight: boolean | undefined;

  @Input() public showImage: boolean = true;

  @Input() public profile: (Profile & { maxTime?: number }) | undefined;

  @Input() public hidePosition: boolean = false;

  @Input() public displayMode: string = 'row';

  @Input() public avatarBoxColor: string = 'primary';

  @Input() public badge?: string | number;

  @Input() public startTime?: string | Date;

  @Input() public endTime?: string | Date;

  @Input() public showArrival?: boolean = false;

  @Input() public showSeniority?: boolean = true;

  @Input() public isGuard: boolean = false;

  @Input() public viewFlex: any;

  @Input() public alignSpecialty: boolean = false;

  @Input() public hideSpecialty: boolean = false;

  @Input() public hideResendency: boolean = false;

  @Input() public isSurgeonSelection: boolean = false;

  @Input() public isBigRow: boolean = false;

  @Input() public isSideNav: boolean = false;

  @Input() public smallAvatar: boolean = false;

  @Input() public smallSpecialty: boolean = false;

  @Input() public smallName: boolean = false;

  @Input() public tinyMode: boolean = false;

  @Input() public isSmartPlanningDesign: boolean = false;

  @Input() public isPictureRight: boolean = false;

  @Input() public onlyResidency: boolean = false;

  @Input() public showTooltip: boolean = false;

  @Input() public hideHospital: boolean = false;

  @Input() public programRecap: boolean = false;

  @Input() public isAnnuaire: boolean = false;

  @Input() public isImportProfile: boolean = false;

  @Input() public isAvatarOfTab: boolean = false;

  @Input() public isAccountView: boolean = false;

  @Input() public isStatopView: boolean = false;

  @Input() public isIbodeView: boolean = false;

  @Input() public isMyProgramView: boolean = false;

  @Input() public hospitalSelectedInSurgeonTabStatop: any;

  @Input() public paramedicals: Paramedical[] | undefined;

  @Input() public roles: Role[] | undefined;

  @Input() public role: Role | undefined;

  @Input() public isHome: boolean = false;

  @Input() public pictureBorder = false;

  @Input() public lastNameUpperCase = false;

  @Output() public onChangeRole = new EventEmitter<any>();

  @Input() public nameOverFlow: boolean = false;

  // only right is coded and used at the moment
  @Input() public hoursPosition: string = 'right';

  // hoursLayout: 'row' | 'column'
  @Input() public hoursLayout: string = 'row';

  // Disable bigScreen on some pages
  @Input() public disableBigScreen: boolean = true;

  @Input() public userProfilePic: string | undefined;

  @Input() public nightMode: boolean = false;

  @Input() public totalPresence: string | undefined;

  public allSpecialtiesOfRightType: boolean = true;

  public picture: string | undefined;

  public isBigScreen: boolean = true;

  public isMiddleScreen: boolean = false;

  public totalPresenceHours: number | undefined;

  public isToMuchZoomScreen: boolean = false;

  public isAnestProfile: boolean = false;

  public isSurgeonProfile: boolean = false;

  public availableRoles: Role[] = [];

  public canEditRoles: boolean = false;

  public selectedHospitalInSoloMode: any;

  public specialty: Specialty | undefined;

  public isSurgeon: boolean = false;

  public isMultiHospital: boolean = false;

  public isProfileInNurses: boolean = false;

  public isProfileInSurgeons: boolean = false;

  public isProfileInIades: boolean = false;

  public isProfileInAnesthesistes: boolean = false;

  public isProfileInCDB: boolean = false;

  public hospitalNames: HospitalNames;

  public accessOption: AccessOptions | undefined;

  // private hasTotalPresenceRun: boolean | undefined;

  constructor(
    private readonly storageService: StorageService,
    private readonly userService: UserService,
    private readonly router: Router
  ) {
    this.hospitalNames = this.userService.getHospitalNames();
    this.accessOption = this.userService.getAccessOptionsOfPage(this.router.url);

    this.onResize();
  }

  @HostListener('window:resize', [])
  onResize() {
    const seuilToMuchZoomScreen = 1300;
    if (window.innerWidth <= seuilToMuchZoomScreen) {
      this.isToMuchZoomScreen = true;
    } else {
      this.isToMuchZoomScreen = false;
    }
    let seuilDisableBigScreen = this.isAvatarOfTab ? 1760 : 750;
    let seuildisableMiddleScreen = this.isAvatarOfTab ? 2000 : 950;
    let seuilBigScreen = this.isAvatarOfTab ? 1500 : 950;
    let seuilMiddleScreen = this.isAvatarOfTab ? 2000 : 1050;
    if (
      this.isAnestProfile ||
      (this.isSurgeonProfile &&
        this.profile &&
        this.profile.firstName &&
        this.profile.lastName &&
        this.getSize2Name(this.profile.firstName, this.profile.lastName) < 15)
    ) {
      seuilDisableBigScreen = seuilDisableBigScreen - 100;
      seuildisableMiddleScreen = seuildisableMiddleScreen - 200;
      seuilBigScreen = seuilBigScreen - 200;
      seuilMiddleScreen = seuilMiddleScreen - 200;
    } else if (
      !this.isAnestProfile &&
      !this.isSurgeonProfile &&
      this.profile &&
      this.profile.firstName &&
      this.profile.lastName &&
      this.getSize2Name(this.profile.firstName, this.profile.lastName) < 15
    ) {
      seuilDisableBigScreen = seuilDisableBigScreen - 65;
      seuildisableMiddleScreen = seuildisableMiddleScreen - 65;
      seuilBigScreen = seuilBigScreen - 65;
      seuilMiddleScreen = seuilMiddleScreen - 65;
    }

    if (this.disableBigScreen) {
      this.isBigScreen = true;
    } else {
      if (this.showSeniority) {
        if (window.innerWidth < seuilDisableBigScreen) {
          this.isBigScreen = false;
        } else {
          this.isBigScreen = true;
          if (window.innerWidth < seuildisableMiddleScreen) {
            this.isMiddleScreen = true;
          } else {
            this.isMiddleScreen = false;
          }
        }
      } else {
        if (window.innerWidth < seuilBigScreen) {
          this.isBigScreen = false;
        } else {
          this.isBigScreen = true;
          if (window.innerWidth < seuilMiddleScreen) {
            this.isMiddleScreen = true;
          } else {
            this.isMiddleScreen = false;
          }
        }
      }
    }
  }

  getSize2Name(name1: string | undefined, name2: string | undefined) {
    if (name1 && name2) {
      return name1.length + name2.length + 1;
    } else {
      return 0;
    }
  }

  async ngOnInit(): Promise<void> {
    this.isProfileInNurses = await this.userService.isProfileInNurses(this.profile);
    this.isSurgeon = await this.userService.isProfileInSurgeons(this.profile);
    this.isProfileInSurgeons = await this.userService.isProfileInSurgeons(this.profile);
    this.isProfileInIades = await this.userService.isProfileInIades(this.profile);
    this.isProfileInAnesthesistes = await this.userService.isProfileInAnesthesistes(this.profile);
    this.isProfileInCDB = await this.userService.isProfileInCDB(this.profile);
    this.isMultiHospital = this.userService.isCurrentUserHasMultipleHospitalsSelected();
    this.showSeniority = true;
    if (this.profile) {
      this.isAnestProfile = this.isProfileInAnesthesistes;
      this.isSurgeonProfile = this.isProfileInSurgeons;
      if (this.profile.startingDate) {
        this.profile.startingDate = this.profile.startingDate.substring(0, 10);
      }
      if (this.profile.profilePic && this.profile.profilePic !== '') {
        this.picture = this.profile.profilePic;
      }
      this.initPicture(this.profile.profilePic);
    }

    const currentUser = this.userService.getCurrentUser();
    this.selectedHospitalInSoloMode = getFirstHospitalSelectedData(
      currentUser,
      this.userService.getSelectedHospitals()
    );
    this.getSpecialty();

    const seuilToMuchZoomScreen = 1300;
    if (window.innerWidth <= seuilToMuchZoomScreen) {
      this.isToMuchZoomScreen = true;
    } else {
      this.isToMuchZoomScreen = false;
    }
    let seuilDisableBigScreen = this.isAvatarOfTab ? 1760 : 900;
    let seuilMiddleScreen = this.isAvatarOfTab ? 2000 : 1100;

    if (
      this.isAnestProfile ||
      (this.isSurgeonProfile && this.profile && this.getSize2Name(this.profile.firstName, this.profile.lastName) < 15)
    ) {
      seuilDisableBigScreen = seuilDisableBigScreen - 100;
      seuilMiddleScreen = seuilMiddleScreen - 200;
    } else if (
      !this.isAnestProfile &&
      !this.isSurgeonProfile &&
      this.profile &&
      this.getSize2Name(this.profile.firstName, this.profile.lastName) < 15
    ) {
      seuilDisableBigScreen = seuilDisableBigScreen - 65;
      seuilMiddleScreen = seuilMiddleScreen - 65;
    }
    if (this.disableBigScreen) {
      this.isBigScreen = true;
    } else {
      if (window.innerWidth < seuilDisableBigScreen) {
        this.isBigScreen = false;
      } else {
        this.isBigScreen = true;
        if (window.innerWidth < seuilMiddleScreen) {
          this.isMiddleScreen = true;
        } else {
          this.isMiddleScreen = false;
        }
      }
    }
    if (this.programRecap && (this.isProfileInNurses || this.isProfileInIades) && !this.isHome) {
      this.setProfileRoles();
    }

    if (this.accessOption?.permissionWrite) {
      this.canEditRoles = true;
    }
  }

  setProfileRoles() {
    const paramedical = this.paramedicals
      ? this.paramedicals.find((paramedical: Paramedical) => paramedical?.formation?.name === this.profile?.position)
      : null;
    if (!paramedical) {
      if (this.roles) {
        this.availableRoles = this.roles;
        if (!this.role) {
          this.onChangeRole.emit(this.availableRoles[0]);
        }
      }
    } else {
      let roles: any = paramedical.roles?.sort(function (
        a: {
          roleId: Role;
          priority: number;
        },
        b: {
          roleId: Role;
          priority: number;
        }
      ) {
        if (Number(a.priority) < Number(b.priority)) {
          return -1;
        }
        if (Number(a.priority) > Number(b.priority)) {
          return 1;
        }
        return 0;
      });
      roles = roles.map((role: { roleId: Role; priority: number }) => role.roleId);
      this.availableRoles = roles;
      if (!this.role) {
        // this.role = this.availableRoles[0]
        this.onChangeRole.emit(this.availableRoles[0]);
      }
    }
  }

  formatUTCHours(date: Date | string): string {
    const d = new Date(date);
    let hours = `${d.getUTCHours()}`;
    let minutes = `${d.getUTCMinutes()}`;

    if (hours.length < 2) {
      hours = `0${hours}`;
    }

    if (minutes.length < 2) {
      minutes = `0${minutes}`;
    }

    return `${hours} h ${minutes}`;
  }

  getSpecialty(): void {
    let selectedHospital: Hospital;
    if (this.isStatopView && this.hospitalSelectedInSurgeonTabStatop) {
      selectedHospital = this.hospitalSelectedInSurgeonTabStatop;
    } else {
      selectedHospital = this.selectedHospitalInSoloMode;
    }
    if (this.profile?.specialties && Array.isArray(this.profile.specialties) && selectedHospital) {
      this.allSpecialtiesOfRightType = !this.profile.specialties.some((item) => typeof item === 'string');

      const filteredSpecialties = this.profile.specialties.find(
        (specialty: Specialty) =>
          specialty?.hospital &&
          (typeof selectedHospital === 'string'
            ? String(specialty.hospital) === String(selectedHospital)
            : String(specialty.hospital) === String(selectedHospital._id))
      );
      if (filteredSpecialties) {
        this.specialty = filteredSpecialties;
      }
    }
  }

  compareRole(a: Role, b: Role) {
    if (a && b) {
      return String(a._id) === String(b._id);
    } else {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && (this.profile || this.userProfilePic)) {
      if (this.profile?.profilePic && this.profile.profilePic !== '') {
        this.picture = this.profile.profilePic;
      }
      this.initPicture(this.profile?.profilePic);
      this.getSpecialty();
      if (this.programRecap && (this.isProfileInNurses || this.isProfileInIades) && !this.isHome) {
        this.setProfileRoles();
      }
    }
    if (this.totalPresence) {
      this.totalPresenceHours = parseInt(this.totalPresence[0] + this.totalPresence[1]);
    }
  }

  onRoleChange(event: any) {
    this.onChangeRole.emit(event);
  }

  onAvatarError(): void {
    let picture: string;
    if (!this.isSurgeonSelection) {
      if (this.isProfileInNurses) {
        picture = 'assets/images/icons/nurse.svg';
      } else if (this.isProfileInSurgeons || this.isProfileInCDB) {
        picture = 'assets/images/icons/surgeon.svg';
      } else if (this.isProfileInIades || this.isProfileInAnesthesistes) {
        picture = 'assets/images/icons/f-doctor.svg';
      } else {
        picture = 'assets/images/icons/nurse.svg';
      }
    } else {
      picture = 'assets/images/icons/surgeon.svg';
    }
    this.picture = picture;
  }

  getDateFormat(date: Date | string) {
    return moment(date).format('DD/MM/YYYY');
  }

  initPicture(image: string | undefined): void {
    if (!image) {
      this.onAvatarError();
    } else {
      this.picture = image;
    }
  }

  public get fxLayoutAlign() {
    return this.displayMode === 'row' ? 'start center' : 'center center';
  }

  public get isColumn() {
    return this.displayMode === 'column';
  }

  public get fullName(): any {
    const reverseNameOrder = this.storageService.getData('reverseOrderName');

    const firstName = this.profile?.firstName || '';
    const lastName = this.profile?.lastName || '';

    if (this.lastNameUpperCase) {
      lastName.toUpperCase();
    }

    if (!this.isBigScreen) {
      if (reverseNameOrder === true && firstName !== 'Dr') {
        return (lastName ? lastName.substring(0, 3) + '. ' : '') + (firstName ? firstName[0] + '.' : '');
      } else {
        return (firstName ? firstName[0] + '. ' : '') + (lastName ? lastName.substring(0, 3) + '.' : '');
      }
    } else {
      const name =
        reverseNameOrder === true && firstName !== 'Dr' ? `${lastName} ${firstName}` : `${firstName} ${lastName}`;
      return !this.clipName || name.length <= 15 ? name : name.slice(0, 15);
    }
  }

  getSeniority(seniority: string) {
    switch (seniority) {
      case 'Senior':
        return 'Sénior';
      case 'Junior':
        return 'Junior';
      case 'Interne':
        return 'Interne';
      default:
        return 'Undefined';
    }
  }

  truncatePositionForBigAndMiddleScreen(position: string | undefined) {
    //ajouter screenSize
    if (!position) {
      return '';
    }
    const inputString = position;
    if (inputString.length <= 11) {
      return inputString;
    } else {
      return inputString.substring(0, 11) + '...';
    }
  }

  truncateSpecialtyForBigAndMiddleScreen(specialty: Specialty | undefined) {
    if (!specialty) {
      return '';
    }
    const inputString = specialty.name;
    if (inputString.length <= 13) {
      return inputString;
    } else {
      if (specialty.diminutif) {
        return specialty.diminutif;
      } else {
        return inputString.substring(0, 13) + '...';
      }
    }
  }

  truncateSpecialtyForNotBigScreen(specialty: Specialty | undefined) {
    if (!specialty) {
      return '';
    }
    const inputString = specialty.name;
    if (this.isToMuchZoomScreen) {
      if (specialty.diminutif) {
        return specialty.diminutif;
      } else {
        return '...';
      }
    }
    if (inputString.length <= 8) {
      return inputString;
    } else {
      return inputString.substring(0, 8) + '...';
    }
  }
}
